import ShareByEmailForm, {
  defaultMessage,
  validate,
} from './share-by-email-form'

export { defaultMessage, validate }
export default ShareByEmailForm
